const DEFAULT_BOARD_STATUS_COLOR = "#94a3b8";

export const getBoardStatusColor = (
  status: string | undefined | null,
  statusColors?: Record<string, string>,
): string => {
  const value = String(status ?? "").trim();
  if (value && statusColors && statusColors[value]) {
    return statusColors[value];
  }
  return DEFAULT_BOARD_STATUS_COLOR;
};
